module.exports = __webpack_public_path__ + "img/enterprise-null.0fe6f33d.png";